// extracted by mini-css-extract-plugin
module.exports = {"page":"rawData_page__2h2Oj","page__links":"rawData_page__links__2OQgd"};